import { gql, useQuery } from "@apollo/client";

const GET_DASHBOARD_EXTRA_KPIS_YTD = gql`
  query getDashboardExtraKpisYtd {
    getDashboardExtraKpisYtd {
      organizationSalesGoal
      percentToGoal
      pace
      jobsWonCount
      averageProposalAmount
      totalPipeline
      weightedPipeline
      weightedForecast30Days
      weightedForecast60Days
    }
  }
`;

export function useGetDashboardExtraKpis() {
  const { data, loading, error } = useQuery(GET_DASHBOARD_EXTRA_KPIS_YTD, {
    fetchPolicy: "cache-first",
  });

  return {
    extraKpis: data?.getDashboardExtraKpisYtd,
    extraKpisLoading: loading,
    extraKpisError: error,
  };
}
